import { CardHeader, CardTitle } from "./ui/card";

export function ChartCardHeader({ title, actions = null }) {
  return (
    <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-3 space-y-0 pb-2">
      <CardTitle className="text-lg">{title}</CardTitle>
      <div className="flex flex-wrap items-center justify-end gap-3">
        {actions}
      </div>
    </CardHeader>
  );
}
